export default (() => {
    $('.faq-accordion').click(function() {
        if($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).find('.content-text').toggle();
            return;
        }

        $(this).addClass('open');
        $(this).find('.content-text').toggle();
    })
});



// WEBPACK FOOTER //
// ./scripts/components/faq-accordion.js